export default __webpack_public_path__ + "static/media/three_pods_loader.ab9d8b93.gif";